import { USER_LIST_VIEWS } from "lookup";

const STORAGE_PREFIX = "userListPreferences";

const LEGACY_VIEW_VALUES = {
  "Career Track": USER_LIST_VIEWS.MATCH_AGENT,
};

const getUserPreferenceKey = (user) => {
  const userKey =
    user?.id ||
    user?.username ||
    user?.email ||
    user?.attributes?.sub ||
    user?.attributes?.email ||
    "anonymous";

  return `${STORAGE_PREFIX}:${userKey}`;
};

const getDefaultPreferences = () => ({
  viewType: USER_LIST_VIEWS.FULL_PROFILE,
  careerTrackAnalysisEnabled: false,
});

export const normalizeUserListViewType = (viewType) =>
  LEGACY_VIEW_VALUES[viewType] || viewType;

export const getUserListPreferences = (user) => {
  if (typeof window === "undefined") {
    return getDefaultPreferences();
  }

  try {
    const storedValue = window.localStorage.getItem(getUserPreferenceKey(user));
    const storedPreferences = storedValue ? JSON.parse(storedValue) : {};

    return {
      ...getDefaultPreferences(),
      ...storedPreferences,
      viewType: normalizeUserListViewType(
        storedPreferences.viewType || USER_LIST_VIEWS.FULL_PROFILE
      ),
    };
  } catch (error) {
    console.warn("Unable to load user list preferences", error);
    return getDefaultPreferences();
  }
};

export const saveUserListPreferences = (user, preferences) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const currentPreferences = getUserListPreferences(user);
    window.localStorage.setItem(
      getUserPreferenceKey(user),
      JSON.stringify({
        ...currentPreferences,
        ...preferences,
      })
    );
  } catch (error) {
    console.warn("Unable to save user list preferences", error);
  }
};
